import { IconEditOrders } from '../../../../../../../../assets/DesignSystem/SVGComponents';
import { formatShortDate } from '../../../../../../../../utils/formatDatesAndHours';
import './TrackingAndDatesSection.scss';

interface ITracking {
  trackingLink: string;
  trackingCode: string;
  estimatedDeliveryDate: string;
}

const StockOrderShipmentTrackingData = ({
  tracking,
  countryTimeZone,
  setShowProcessModal,
  setIsEditedProcessModal
}: {
  tracking: ITracking;
  countryTimeZone?: number;
  setShowProcessModal: React.Dispatch<React.SetStateAction<boolean>>;
  setIsEditedProcessModal: React.Dispatch<React.SetStateAction<boolean>>;
}) => {
  const { trackingLink, trackingCode, estimatedDeliveryDate } = tracking || {};

  const noDataText = 'Sin datos';
  const trackingLinkIsValid = trackingLink && (trackingLink.includes('http://') || trackingLink.includes('https://'));
  const linkStyles = trackingLinkIsValid ? 'link' : '';

  const openUrl = () => {
    if (trackingLinkIsValid) {
      window.open(trackingLink, '_blank');
    }
  };

  const handleEditEstimatedDates = () => {
    setShowProcessModal(true);
    setIsEditedProcessModal(true);
  };

  return (
    <div className="shipmentTrackingData active">
      {estimatedDeliveryDate && (
        <div className="estimatedDatesSection">
          <div className="trackingDataField estimatedDate">
            Fecha limite estimada: {formatShortDate(estimatedDeliveryDate, countryTimeZone)?.textWithTimezone}
            <IconEditOrders onClick={handleEditEstimatedDates} className="marginIcon" />
          </div>
        </div>
      )}
      {trackingLink && (
        <div className="trackingDataField trackingLinkField">
          Link de rastreo:{' '}
          <div className={linkStyles} onClick={openUrl}>
            {trackingLink || noDataText}
          </div>
        </div>
      )}
      {trackingCode && <div className="trackingDataField">Código: {trackingCode || noDataText}</div>}
    </div>
  );
};

export default StockOrderShipmentTrackingData;
